export default "__VITE_ASSET__raTITyNH__"